module.exports = __webpack_public_path__ + "static/media/muji product design.eb10635a.png";